export function isVideo(url: string): boolean {
  const valideVideoExtends: string[] = ['.mp4', '.avi', '.flv', '.webm']
  return valideVideoExtends.some((extend) => url.toLowerCase().lastIndexOf(extend) > -1)
}

// 构建tailwind css， common是公用的样式，
// mobile是小屏幕的样式
// pc是大屏幕的样式，会自动给它增加laptop: 前缀
export function twcls(common: string, mobile: string, pc: string): string {
  const pcClsParts = pc.split(' ').filter((s) => Boolean(s))
  return [common, mobile, pcClsParts.map((s) => 'laptop:' + s).join(' ')].join(' ')
}

export function buildQuery(params: Record<string, any>): string {
  const keys = Object.keys(params ?? Object.create(null))
  const queryArr = []
  for (let key of keys) {
    if (!params.hasOwnProperty(key)) {
      continue
    }
    const value = params[key]
    // NOTE: value need encode encodeURIComponent
    queryArr.push(`${key}=${encodeURIComponent(value)}`)
  }

  return queryArr.join('&')
}

export async function sha256(text?: string): Promise<string> {
  // convert to string
  if (!text) {
    return ''
  }

  const utf8Text = new TextEncoder().encode(text)
  const hasHex = await crypto.subtle.digest('SHA-256', utf8Text).then((hashBuffer) => {
    const hashArray = Array.from(new Uint8Array(hashBuffer))
    const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('')
    return hashHex
  })

  return hasHex
}

export function isDataEmpty(data: any) {
  if (!data || typeof data !== 'object') return true
  return Object.values(data).every((value): boolean => {
    if (Array.isArray(value)) return value.length === 0
    if (typeof value === 'object' && value !== null) return isDataEmpty(value)
    return value === '' || value === null || value === undefined
  })
}
